import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Session invalide');
          navigate('/auth');
          return;
        }

        // Send session_id to backend
        const response = await api.post('/auth/google/session', { session_id: sessionId });

        if (response.data.success && response.data.user) {
          // Store user in context
          setUser(response.data.user);
          
          // Store token for API calls
          localStorage.setItem('token', sessionId);
          
          toast.success(`Bienvenue ${response.data.user.name || response.data.user.email} !`);
          
          // Navigate to dashboard with user data
          navigate('/dashboard', { state: { user: response.data.user } });
        } else {
          throw new Error('Invalid response');
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Erreur d\'authentification');
        navigate('/auth');
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <h2 className="text-2xl font-bold text-gray-900">
          Connexion en cours...
        </h2>
        <p className="text-gray-600 mt-2">Veuillez patienter</p>
      </div>
    </div>
  );
};

export default AuthCallback;
